var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "rodape" },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { md: 12, sm: 12, xs: 12 } }, [
            _c("div", { staticClass: "imagem-governo" })
          ]),
          _vm.FOOTER.EXIBIR_REDES_SOCIAIS
            ? _c(
                "el-col",
                {
                  staticClass: "posicao-icones",
                  attrs: { md: 12, sm: 12, xs: 12 }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "posicao-icone",
                      attrs: {
                        href: _vm.FOOTER.FACEBOOK,
                        title: "Curta nossa página no Facebook",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "borda_img",
                        attrs: {
                          src: require("@/assets/images/facebook-icon-circular.svg"),
                          alt: "Facebook"
                        }
                      })
                    ]
                  ),
                  _vm.FOOTER.TWITTER
                    ? _c(
                        "a",
                        {
                          staticClass: "posicao-icone",
                          attrs: {
                            href: _vm.FOOTER.TWITTER,
                            title: "Siga nosso Twitter",
                            target: "_blank",
                            rel: "noopener"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "borda_img",
                            attrs: {
                              src: require("@/assets/images/twitter-icon-circular.svg"),
                              alt: "Twitter"
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "a",
                    {
                      staticClass: "posicao-icone",
                      attrs: {
                        href: _vm.FOOTER.YOUTUBE,
                        title: "Assine nosso Canal no Youtube",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "borda_img",
                        attrs: {
                          src: require("@/assets/images/youtube-icon-circular.svg"),
                          alt: "Youtube"
                        }
                      })
                    ]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "posicao-icone",
                      attrs: {
                        href: _vm.FOOTER.INSTAGRAM,
                        title: "Siga nossa página no Instagram",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "borda_img",
                        attrs: {
                          src: require("@/assets/images/instagram-icon-circular.svg"),
                          alt: "Instagram"
                        }
                      })
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { id: "hiddenslider" } },
        [
          _c(
            "el-col",
            { staticClass: "posicao-links", attrs: { md: 12, sm: 24 } },
            [
              _c(
                "a",
                { staticClass: "link", attrs: { href: "#/publico/home" } },
                [_vm._v(_vm._s(_vm.FOOTER.O_SICARF) + " |")]
              ),
              _vm.EXIBIR_COMO_BAIXAR
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: { href: "#/publico/baixar" }
                    },
                    [_vm._v(" Como baixar |")]
                  )
                : _vm._e(),
              _vm.EXIBIR_COMO_ENVIAR
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: { href: "#/publico/enviar" }
                    },
                    [_vm._v(" Como enviar seu pedido |")]
                  )
                : _vm._e(),
              _c(
                "a",
                { staticClass: "link", attrs: { href: "#/publico/central" } },
                [_vm._v(" Central do interessado")]
              ),
              _vm.EXIBIR_CONSULTA.PROCESSO
                ? _c(
                    "a",
                    { staticClass: "link", attrs: { href: "#/publico/geral" } },
                    [_vm._v(" | Faça sua consulta")]
                  )
                : _vm._e(),
              _vm.FOOTER.EXIBIR_INFORMACAO
                ? _c(
                    "a",
                    {
                      staticClass: "link",
                      attrs: { href: "#/publico/informacao/duvidasFrequentes" }
                    },
                    [_vm._v(" | Informação")]
                  )
                : _vm._e()
            ]
          ),
          _vm.FOOTER.EXIBIR_REDES_SOCIAIS
            ? _c(
                "el-col",
                { staticClass: "posicao-icones", attrs: { md: 12, sm: 24 } },
                [
                  _c("span", [_vm._v(_vm._s(_vm.FOOTER.ENDERECO))]),
                  _c("br"),
                  _vm._v(" " + _vm._s(_vm.FOOTER.CEP))
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3916eeae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3916eeae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/Footer.vue
// module id = null
// module chunks = 